import { render, staticRenderFns } from "./NovoClienteModal.vue?vue&type=template&id=82854410"
import script from "./NovoClienteModal.vue?vue&type=script&lang=js"
export * from "./NovoClienteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports